import type { JSX } from 'react'

export const RestartIcon = (): JSX.Element => (
  <use href='#restartIcon' height='100%' width='100%' />
)
